var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 24,
    viewBox: "0 0 5 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.7313 11.8646C4.7313 13.0968 3.73233 14.0958 2.50005 14.0958C1.26776 14.0958 0.268799 13.0968 0.268799 11.8646C0.268799 10.6323 1.26776 9.6333 2.50005 9.6333C3.73233 9.6333 4.7313 10.6323 4.7313 11.8646Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7313 2.93981C4.7313 4.17209 3.73233 5.17106 2.50005 5.17106C1.26776 5.17106 0.268799 4.17209 0.268799 2.93981C0.268799 1.70752 1.26776 0.708557 2.50005 0.708557C3.73233 0.708557 4.7313 1.70752 4.7313 2.93981Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7313 20.7899C4.7313 22.0222 3.73233 23.0212 2.50005 23.0212C1.26776 23.0212 0.268799 22.0222 0.268799 20.7899C0.268799 19.5576 1.26776 18.5587 2.50005 18.5587C3.73233 18.5587 4.7313 19.5577 4.7313 20.7899Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVertical);
export default __webpack_public_path__ + "static/media/more_vertical.8e67c232a0abff0a258d2dc2d9fd0b02.svg";
export { ForwardRef as ReactComponent };